/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'
import { dollarize } from '@zcode/utils'
import { PRICE_PER_NIGHT_LEASE_DAYS } from '../../../../shared/constants/filter'

export const getPricePerNight = ({ features, minPrice, price }: Listable | Pin | Property) => {
  let listingPrice = price || minPrice || 0

  if (!features?.includes(PropertyFeatures.NIGHTLY_PRICING)) {
    listingPrice = Math.round(listingPrice / PRICE_PER_NIGHT_LEASE_DAYS)
  }

  return dollarize(listingPrice)
}
